import { browseTips } from "@/mocks/gallery";
import Reveal from "@/pages/home/components/Reveal";

export default function BrowseTips() {
  return (
    <section className="py-16 md:py-24 bg-secondary-50">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="max-w-3xl mb-10">
            <span className="text-xs font-label tracking-widest text-secondary-700 uppercase">How to Browse</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">浏览小贴士</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-700">
              几个简单的使用建议，能帮你在内容较多的页面里更快定位，也方便后续回访时直接找到熟悉的分区。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {browseTips.map((tip, index) => (
            <Reveal key={tip.id} delay={index * 60}>
              <article className="h-full flex gap-4 rounded-lg bg-background-50 border border-secondary-200/70 p-5">
                <span className="shrink-0 w-11 h-11 rounded-md bg-secondary-500 flex items-center justify-center text-background-50">
                  <i className={`${tip.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{tip.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}